const LOGGER_TOGGLE = 'FE_LOGGER'

const createLogger = (namespace: string) => {
  const isEnabled = localStorage.getItem(LOGGER_TOGGLE) === 'true'
  const formatMessage = (message: string): string => {
    return `[${namespace}]: ${message}`
  }

  const logWithLevel = (
    level: string,
    message: string,
    ...args: unknown[]
  ): void => {
    if (!isEnabled) return

    const formattedMessage = formatMessage(message)

    switch (level) {
      case 'log':
        console.log(formattedMessage, ...args)
        break
      case 'warn':
        console.warn(formattedMessage, ...args)
        break
      case 'error':
        console.error(formattedMessage, ...args)
        break
      case 'info':
        console.info(formattedMessage, ...args)
        break
      case 'debug':
        console.debug(formattedMessage, ...args)
        break
    }
  }

  return {
    log: (message: string, ...args: unknown[]) =>
      logWithLevel('log', message, ...args),
    warn: (message: string, ...args: unknown[]) =>
      logWithLevel('warn', message, ...args),
    error: (message: string, ...args: unknown[]) =>
      logWithLevel('error', message, ...args),
    info: (message: string, ...args: unknown[]) =>
      logWithLevel('info', message, ...args),
    debug: (message: string, ...args: unknown[]) =>
      logWithLevel('debug', message, ...args),
  }
}

export default createLogger
